export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const DATE_FORMAT = 'DD.MM.YYYY';
